import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
export function MouseFollower() {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);
  const springConfig = {
    damping: 25,
    stiffness: 200,
    mass: 0.5
  };
  const x = useSpring(cursorX, springConfig);
  const y = useSpring(cursorY, springConfig);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      cursorX.set(e.clientX);
      cursorY.set(e.clientY);
      if (!isVisible) setIsVisible(true);
    };
    const handleMouseEnter = () => setIsVisible(true);
    const handleMouseLeave = () => setIsVisible(false);
    // Detect hovering over interactive elements
    const handleElementHover = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const interactive = target.closest('a, button, input, textarea, select, [role="button"]');
      setIsHovering(!!interactive);
    };
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handleElementHover);
    document.addEventListener('mouseenter', handleMouseEnter);
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handleElementHover);
      document.removeEventListener('mouseenter', handleMouseEnter);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [cursorX, cursorY, isVisible]);
  // Hide on touch devices
  if (typeof window !== 'undefined' && 'ontouchstart' in window) {
    return null;
  }
  return <>
      {/* Outer ring */}
      <motion.div className="fixed top-0 left-0 pointer-events-none z-[9999] mix-blend-difference" style={{
      x,
      y,
      translateX: '-50%',
      translateY: '-50%'
    }} animate={{
      opacity: isVisible ? 1 : 0,
      scale: isHovering ? 1.5 : 1
    }} transition={{
      opacity: {
        duration: 0.2
      },
      scale: {
        type: 'spring',
        stiffness: 300,
        damping: 20
      }
    }} data-id="element-128">
        <div className="rounded-full border-2 border-gold/40" style={{
        width: isHovering ? 48 : 40,
        height: isHovering ? 48 : 40,
        transition: 'width 0.3s, height 0.3s'
      }} data-id="element-129" />
      </motion.div>

      {/* Inner dot */}
      <motion.div className="fixed top-0 left-0 pointer-events-none z-[9999]" style={{
      x: cursorX,
      y: cursorY,
      translateX: '-50%',
      translateY: '-50%'
    }} animate={{
      opacity: isVisible ? 1 : 0,
      scale: isHovering ? 0.5 : 1
    }} transition={{
      opacity: {
        duration: 0.2
      },
      scale: {
        type: 'spring',
        stiffness: 300,
        damping: 20
      }
    }} data-id="element-130">
        <div className="w-3 h-3 rounded-full bg-gold" data-id="element-131" />
      </motion.div>
    </>;
}